import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import DataTableActions from "../../components/datatable/data-table-actions";
import DataTableBase from "../../components/datatable/data-table-base";
import {useBuildingStatService} from "../../services/building-stat-service";
import AddEditBuildingStatModal from "./add-edit-building-stat-modal";
import BuildingStatsSyncModal from "./building-stats-sync-modal";


export default function BuildingStatsList () {
  let buildingStatService = useBuildingStatService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const addEditModal = useRef();
  const buildingStatsSyncModal = useRef();

  useEffect(()=>{
   reloadList();
  }, []);

  const reloadList = ()=>{
    setLoaded(false);
    buildingStatService.getList()
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  };

  const onAddEditAction = (row=null, e=null)=>{
    addEditModal.current.openModal(row);
  };

  const onAddEditCallbackAction = (item=null)=>{
    setRows(HelperService.addOrReplaceItemInList(rows,item));
  };

  const openImportModal = ()=>{
    buildingStatsSyncModal.current.openModal();
  };

  const onDelAction = (item, e=null)=>{
    if (true===confirm('Naozaj odstrániť záznam?')){
      buildingStatService.delModel(item.id)
        .then(()=>{
          setRows(HelperService.removeItemFromList(rows,item));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const columns = [{
    name: 'Budova',
    selector: row => row.building?.title,
    sortable: true,
  },{
    name: 'Typ',
    selector: row => row.building_stat_type?.title,
    sortable: true,
  },{
    name: 'Dátum',
    selector: row => row.date_at,
    format: row => { return HelperService.formatDate(row.date_at) },
    sortable: true,
  },{
    name: 'Hodnota',
    selector: row => row.stat,
    sortable: true,
  },{
    cell: row => <DataTableActions row={row} actions={[
      {title: 'Upraviť', icon: <span className="mdi mdi-book-edit-outline"></span>, action: onAddEditAction, className: 'hover-text-primary'},
      {title: 'Zmazať', icon: <span className="mdi mdi-trash-can-outline"></span>, action: onDelAction, className: 'hover-text-danger'},
    ]} />,
    right: true,
    allowOverflow: true,
    button: false,
  }];

  return (
    <>
      <AddEditBuildingStatModal ref={addEditModal} onSuccess={onAddEditCallbackAction} />
      <BuildingStatsSyncModal ref={buildingStatsSyncModal} onSuccess={reloadList} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Údaje pre budovy</PageTitle>

          <button className="btn btn-primary mb-2 me-2" onClick={(e)=>onAddEditAction(null, e)}><span className="mdi mdi-plus"></span> Pridať</button>
          <button className="btn btn-light mb-2" onClick={(e)=>openImportModal()}><span className="mdi mdi-database-import"></span> Synchronizovať</button>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                  <DataTableBase
                    progressPending={!loaded}
                    columns={columns}
                    data={rows}
                    dense
                    // onRowClicked={(row)=>navigate(`${AppRoutes.users.path}/${row.id}`)}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

BuildingStatsList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

BuildingStatsList.getSEO = function getSEO() {
  return {
    title: "Správa údajov pre budovu",
  }
}
